// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--2iBj0","title":"_93444fe79c--title--1QwlY","link":"_93444fe79c--link--1iPj6","consultant-img":"_93444fe79c--consultant-img--37ELY"};